import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from '@xstate/react';
import { useAtom } from 'jotai';
import usePaymentFlowMachine from '../../hooks/machines/usePaymentFlowMachine';
import { MakeAPaymentView, useCurrentViewAtom } from '../../store/currentViewAtom';
import { multiPaymentStateAtom, useIsErrorView, useMultiPaymentQueryAtoms } from '../../store/multiPaymentAtoms';
import MultiPaymentConfirmation from './DigitalCollections/MultiPaymentConfirmation';
import MultiPaymentDetails from './DigitalCollections/MultiPaymentFlow/MultiPaymentDetails';
import MultiPaymentError from './DigitalCollections/MultiPaymentFlow/MultiPaymentError';
import MultiPaymentReview from './DigitalCollections/MultiPaymentReview';
import XStateCore from './XStateCore';
const JotaiCore = ({ headerRef, mainService, handleClose, handleTabSwitch }) => {
    var _a;
    const mainMachineState = useSelector(mainService, (state) => state);
    const [, oneTimePaymentActor] = usePaymentFlowMachine();
    const [currentViewAtom] = useCurrentViewAtom();
    const [, setIsErrorView] = useIsErrorView();
    const [multiPaymentState, setMultiPaymentState] = useAtom(multiPaymentStateAtom);
    const { settlementEligibilityQueryResult: { data: settlementEligibilityQueryResult } } = useMultiPaymentQueryAtoms();
    const form = useForm({
        mode: 'onChange',
        defaultValues: multiPaymentState
    });
    const hasMoreThanOneSettlementPayment = ((_a = settlementEligibilityQueryResult === null || settlementEligibilityQueryResult === void 0 ? void 0 : settlementEligibilityQueryResult.paymentArrangementPlans) === null || _a === void 0 ? void 0 : _a.length) > 1;
    useEffect(() => {
        // This is temporary until we add an error page on the conditional on line 95
        if (!settlementEligibilityQueryResult)
            setIsErrorView(true);
        else
            setIsErrorView(false);
    }, [setIsErrorView, setMultiPaymentState, settlementEligibilityQueryResult]);
    if (!settlementEligibilityQueryResult) {
        return null;
    }
    if (!hasMoreThanOneSettlementPayment ||
        mainMachineState.matches('open.managePaymentMethod') ||
        !oneTimePaymentActor.matches('edit')) {
        return _jsx(XStateCore, { headerRef: headerRef, mainService: mainService });
    }
    return (_jsxs(FormProvider, Object.assign({}, form, { children: [(currentViewAtom.view === MakeAPaymentView.MultiPaymentDetails ||
                currentViewAtom.view === MakeAPaymentView.MultiPaymentDetailsEdit) && (_jsx(MultiPaymentDetails, { handleCancel: handleClose, handleTabSwitch: handleTabSwitch, headerRef: headerRef, mainService: mainService })), currentViewAtom.view === MakeAPaymentView.MultiPaymentReview && (_jsx(MultiPaymentReview, { handleCancel: handleClose })), currentViewAtom.view === MakeAPaymentView.MultiPaymentConfirmation && (_jsx(MultiPaymentConfirmation, { handleClose: handleClose })), currentViewAtom.view === MakeAPaymentView.MultiPaymentError && (_jsx(MultiPaymentError, { handleClose: handleClose }))] })));
};
export default JotaiCore;
